import { AssetsProvider, Image, Link, styled, Text, useQuery } from '@obvio/app'
import { Loading, Stack } from '@obvio/ui'
import { useCallback } from 'react'

import {
  CarouselBase,
  CarouselDivider,
  CarouselImage,
  CarouselSection,
} from './CarouselBase'
import { getImage } from '../../utils'
import { QUERIES } from '@/constants/queries'

import type { ImageAsset } from '@obvio/app'
import type { ReactElement } from 'react'

const EventWrap = styled(Stack)`
  width: 25.875rem;
  height: 100%;
  color: ${(theme) => theme.colors.secondary};
  text-align: left;
`

type Offer = {
  id: string
  title: string
  image: ImageAsset
  description: string
  slug: string
  profitroomId: string
}

const EventTitle = styled(Text)`
  font-size: 1.25rem;
  line-height: 100%;
  font-family: ${(theme) => theme.font};
`

const Description = styled(Text)`
  font-size: 1rem;
`

const LinkWrapper = styled(Link)`
  all: unset;
  cursor: pointer;
  transition: all 0.2s;
  :hover {
    opacity: 0.5;
  }
`

type OfferCompProps = {
  event: Offer
}

function OfferComp({ event }: OfferCompProps) {
  return (
    <EventWrap kind="vertical" spacing="medium">
      <CarouselImage>
        <Image img={getImage(event.image)} context={event.id} />
      </CarouselImage>
      <CarouselDivider />
      <LinkWrapper href={`/pakiety/${event.slug}`}>
        <Stack kind="vertical">
          <EventTitle tag="h3">{event.title}</EventTitle>
          {/** TODO: Don't blindly add `...` at the end */}
          <Description>{event.description.slice(0, 150)}...</Description>
        </Stack>
      </LinkWrapper>
    </EventWrap>
  )
}

export function PackagesCarousel(): ReactElement {
  const { data: offers, loading } = useQuery('getProfitroomOffers', {
    select: QUERIES['packages-carousel'].getProfitroomOffers,
  })

  const comp = useCallback((event: Offer) => <OfferComp event={event} />, [])

  if (loading) {
    return <Loading />
  }

  return (
    <AssetsProvider path="/offer">
      <CarouselSection>
        <CarouselBase data={offers ?? []} render={comp} />
      </CarouselSection>
    </AssetsProvider>
  )
}
